enum EParticipantHoldsMode {
    Selectable = "selectable",
    Presentation = "presentation"
}

type TParticipantHoldSession = { startDate: string; endDate: string }

type TParticipantHoldFirstSessionGetter = (
    sessions: TParticipantHoldSession[],
    setIndex: number
) => TParticipantHoldSession
type TParticipantHoldRestSessionsGetter = (
    sessions: TParticipantHoldSession[],
    setIndex: number
) => TParticipantHoldSession[]

type TParticipantHoldProps =
    | {
          firstSessionGetter: TParticipantHoldFirstSessionGetter
          restSessionsGetter: TParticipantHoldRestSessionsGetter
          sessions: TParticipantHoldSession[]
          setIndex: number
          mode: EParticipantHoldsMode.Presentation
          isSelected: undefined
      }
    | {
          firstSessionGetter: TParticipantHoldFirstSessionGetter
          restSessionsGetter: TParticipantHoldRestSessionsGetter
          sessions: TParticipantHoldSession[]
          setIndex: number
          mode: EParticipantHoldsMode
          isSelected: boolean
      }

type TParticipantHoldsProps =
    | {
          firstSessionGetter: TParticipantHoldFirstSessionGetter
          restSessionsGetter: TParticipantHoldRestSessionsGetter
          sessionsSet: Record<string, TParticipantHoldSession[]>
          className?: string
          mode: EParticipantHoldsMode.Presentation
          onHoldSelect?: undefined
      }
    | {
          firstSessionGetter: TParticipantHoldFirstSessionGetter
          restSessionsGetter: TParticipantHoldRestSessionsGetter
          sessionsSet: Record<string, TParticipantHoldSession[]>
          className?: string
          mode: EParticipantHoldsMode.Selectable
          onHoldSelect(id: string[]): void
      }

export { EParticipantHoldsMode }
export type {
    TParticipantHoldFirstSessionGetter,
    TParticipantHoldRestSessionsGetter,
    TParticipantHoldProps,
    TParticipantHoldSession,
    TParticipantHoldsProps
}
